import ReactDateTime from 'react-datetime';
import styled from 'styled-components';
import { InputGroup } from 'react-bootstrap';

export const InputGroupContainer = styled(InputGroup)`
  flex-wrap: ${(props) => (props.flexWrap ? 'wrap' : 'nowrap')};
  position: relative;
`;

export const StyledDateTimePicker = styled(ReactDateTime)`
  .rdtPicker {
    z-index: 999 !important;
  }
`;
